import { inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface ProductEnableInventoryControlParams {
    readonly id: number;
}

export type ProductEnableInventoryControlResponse = {
    id: number,
    version: string
};

export class ProductEnableInventoryControlCommand extends Command<ProductEnableInventoryControlParams, ProductEnableInventoryControlResponse> { }

@CommandHandlerFor(ProductEnableInventoryControlCommand)
@Injectable({ providedIn: 'root'})
export class ProductEnableInventoryControlCommandHandler implements CommandHandler<ProductEnableInventoryControlCommand, ProductEnableInventoryControlParams, ProductEnableInventoryControlResponse> {
    #Url = TaggedUrl.join('products/:id/inventoryControl/enable', [Tags.Api]);
    #http = inject(Http) as HttpService;

    async handleAsync(command: ProductEnableInventoryControlCommand): Promise<ProductEnableInventoryControlResponse> {
        const { data } = await this.#http.put(fillPlaceholders(this.#Url, { id: command.params?.id }));
        return data;
    }
}
